const options = {
    data() {
      return {
        SubmitStatus: {
          Value: null,
          Options: {
            PENDING: "PENDING",
            OK: "OK",
            NOT_FOUND: "NOT_FOUND",
            ERROR: "ERROR"
          }
        },
        States: [
        "Alabama",
        "Alaska",
        "American Samoa",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Federated States of Micronesia",
        "Florida",
        "Georgia",
        "Guam",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Marshall Islands",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Northern Mariana Islands",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Palau",
        "Pennsylvania",
        "Puerto Rico",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virgin Island",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
        entityTypes: ["501(c)(3) non-profit", "For-Profit", "Non-Profit Other"],
        developmentTypes: ["Preservation (occupied)", "New Construction","Rehab (unoccupied or vacant)"],
        proposalTypes: ["HOME – ARP (Full Project)", "HOME – ARP (Mixed)", "Non – LIHTC"],
        lotStructure: ["Lot", "Structure"],
        acqMethod: ["Own", "Under Agreement", "Other"],
        optionalContacts: ["Architect", "Property Management Company", "Consultant"],
        incomeType: ["Employment", "Public assistance", "Social Security", "SSI", "Disability", "Pensions", "Other income"],
        populationServed: ['Seniors','Families','Single mothers','Women','Men','Youth','LGBTQ','Returning citizens','Veterans','Homeless or formerly homeless','Victims of domestic abuse','People with disabilities','People with mental Illness','People with substance abuse','People with HIV/AIDs',"Other (e.g. Alzheimer's)",'Hospice','Workforce','At Risk','General'],
        strategyArea: ["Sharswood Blumberg Choice", "North Central Choice", "Bartram Village Choice", "22nd Police District", "Promise Zone neighborhood"],
        generalPartnerManagingMember: ['General Partner', 'Managing Member', 'Neither'],
        constructionTimeline: ["9", "12", "18", "24"],
        projectAttributes: ["Permanent Affordability", "High Opportunity Area", "Place-Based Strategy Area", "Affordable Preservation", "Permanent Support Housing", "Non-Congregate Shelter", "Conversion of NOAH into Subsidized Affordable Housing"],
        incomePayFrequency: ["Weekly", "Bi-weekly"],
        certificationOptions: ["Initial certification", "Re-certification", "Tenant transfer"],
        numOfBedrooms: ["Studio", "1 bedroom", "2 bedrooms", "3 bedrooms", "4 bedrooms", "5 bedrooms"],
        yesNo: ["Yes", "No"],
        yesNoNA: ["Yes", "No", "N/A"],
        gasElectric: ['Gas', 'Electric'],
        MultipleChoiceFieldOptions: {
          Race: ['Black or African American', 'American Indian or Alaska Native', 'Native Hawaiian or Other Pacific Islander', 'Asian', 'White', 'More Than One Race', 'Prefer not to say'],
          Months: ["January","February","March","April","May","June","July",
            "August","September","October","November","December"],
          FeeTypes: ["Late", "Legal", "Repair", "Key", "Water", "Pet", "Security Deposit", "Application", "NSF", "Admin", "Parking"],
          Ethnicity: ["Not Hispanic or Latino",
            "Hispanic/Latino",
            "Prefer not to say",
          ],
          Gender: ["Female",
            "Male",
            "Trans Woman (MTF)",
            "Trans Male (FTM)",
            "Gender Non-Conforming (i.e. not exclusively male or female)",
            "Choose not to respond",
          ],
          YesNo: ["Yes", "No"],
          //YesNoExpanded: ["Yes", "Maybe", "Unlikely", "No"],
          YesNoNotSure: ["Yes", "No", "Not Sure"],
          AgreementScale: ["Strongly Disagree", "Disagree", "Agree", "Strongly Agree"],
          //PaymentComfortScale: ["1: Very Comfortable", "2: Somewhat Comfortable", "3: Not Comfortable", "4: Very Uncomfortable"],
          Countries: [
            "United States",
            "Afghanistan",
            "Aland Islands",
            "Albania",
            "Algeria",
            "American Samoa",
            "Andorra",
            "Angola",
            "Anguilla",
            "Antarctica",
            "Antigua and Barbuda",
            "Argentina",
            "Armenia",
            "Aruba",
            "Australia",
            "Austria",
            "Azerbaijan",
            "Bahamas",
            "Bahrain",
            "Bangladesh",
            "Barbados",
            "Belarus",
            "Belgium",
            "Belize",
            "Benin",
            "Bermuda",
            "Bhutan",
            "Bolivia, Plurinational State of",
            "Bonaire, Sint Eustatius and Saba",
            "Bosnia and Herzegovina",
            "Botswana",
            "Bouvet Island",
            "Brazil",
            "British Indian Ocean Territory",
            "Brunei Darussalam",
            "Bulgaria",
            "Burkina Faso",
            "Burundi",
            "Cambodia",
            "Cameroon",
            "Canada",
            "Cape Verde",
            "Cayman Islands",
            "Central African Republic",
            "Chad",
            "Chile",
            "China",
            "Christmas Island",
            "Cocos (Keeling) Islands",
            "Colombia",
            "Comoros",
            "Congo",
            "Congo, The Democratic Republic of the",
            "Cook Islands",
            "Costa Rica",
            "Cote d'Ivoire",
            "Croatia",
            "Cuba",
            "Curacao",
            "Cyprus",
            "Czech Republic",
            "Denmark",
            "Djibouti",
            "Dominica",
            "Dominican Republic",
            "Ecuador",
            "Egypt",
            "El Salvador",
            "Equatorial Guinea",
            "Eritrea",
            "Estonia",
            "Ethiopia",
            "Falkland Islands (Malvinas)",
            "Faroe Islands",
            "Fiji",
            "Finland",
            "France",
            "French Guiana",
            "French Polynesia",
            "French Southern Territories",
            "Gabon",
            "Gambia",
            "Georgia",
            "Germany",
            "Ghana",
            "Gibraltar",
            "Greece",
            "Greenland",
            "Grenada",
            "Guadeloupe",
            "Guam",
            "Guatemala",
            "Guernsey",
            "Guinea",
            "Guinea-Bissau",
            "Guyana",
            "Haiti",
            "Heard Island and McDonald Islands",
            "Holy See (Vatican City State)",
            "Honduras",
            "Hong Kong",
            "Hungary",
            "Iceland",
            "India",
            "Indonesia",
            "Iran, Islamic Republic of",
            "Iraq",
            "Ireland",
            "Isle of Man",
            "Israel",
            "Italy",
            "Jamaica",
            "Japan",
            "Jersey",
            "Jordan",
            "Kazakhstan",
            "Kenya",
            "Kiribati",
            "Korea, Democratic People's Republic of",
            "Korea, Republic of",
            "Kosovo",
            "Kuwait",
            "Kyrgyzstan",
            "Lao People's Democratic Republic",
            "Latvia",
            "Lebanon",
            "Lesotho",
            "Liberia",
            "Libya",
            "Liechtenstein",
            "Lithuania",
            "Luxembourg",
            "Macao",
            "Macedonia, The Former Yugoslav Republic of",
            "Madagascar",
            "Malawi",
            "Malaysia",
            "Maldives",
            "Mali",
            "Malta",
            "Marshall Islands",
            "Martinique",
            "Mauritania",
            "Mauritius",
            "Mayotte",
            "Mexico",
            "Micronesia, Federated States of",
            "Moldova, Republic of",
            "Monaco",
            "Mongolia",
            "Montenegro",
            "Montserrat",
            "Morocco",
            "Mozambique",
            "Myanmar",
            "Namibia",
            "Nauru",
            "Nepal",
            "Netherlands",
            "New Caledonia",
            "New Zealand",
            "Nicaragua",
            "Niger",
            "Nigeria",
            "Niue",
            "Norfolk Island",
            "Northern Cyprus",
            "Northern Mariana Islands",
            "Norway",
            "Oman",
            "Pakistan",
            "Palau",
            "Palestine, State of",
            "Panama",
            "Papua New Guinea",
            "Paraguay",
            "Peru",
            "Philippines",
            "Pitcairn Islands",
            "Poland",
            "Portugal",
            "Puerto Rico",
            "Qatar",
            "Reunion",
            "Romania",
            "Russian Federation",
            "Rwanda",
            "Western Sahara",
            "Saint Barthelemy",
            "Saint Helena, Ascension and Tristan da Cunha",
            "Saint Kitts and Nevis",
            "Saint Lucia",
            "Saint Martin (French Part)",
            "Saint Pierre and Miquelon",
            "Saint Vincent and the Grenadines",
            "Samoa",
            "San Marino",
            "Sao Tome and Principe",
            "Saudi Arabia",
            "Senegal",
            "Serbia",
            "Seychelles",
            "Sierra Leone",
            "Singapore",
            "Sint Maarten (Dutch Part)",
            "Slovakia",
            "Slovenia",
            "Solomon Islands",
            "Somalia",
            "Somaliland",
            "South Africa",
            "South Georgia and the South Sandwich Islands",
            "South Ossetia",
            "South Sudan",
            "Spain",
            "Sri Lanka",
            "Sudan",
            "Suriname",
            "Svalbard and Jan Mayen",
            "Swaziland",
            "Sweden",
            "Switzerland",
            "Syrian Arab Republic",
            "Taiwan, Province of China",
            "Tajikistan",
            "Tanzania, United Republic of",
            "Thailand",
            "Timor-Leste",
            "Togo",
            "Tokelau",
            "Tonga",
            "Transnistria",
            "Trinidad and Tobago",
            "Tunisia",
            "Turkey",
            "Turkmenistan",
            "Turks and Caicos Islands",
            "Tuvalu",
            "Uganda",
            "Ukraine",
            "United Arab Emirates",
            "United Kingdom",
            "United States Minor Outlying Islands",
            "Uruguay",
            "Uzbekistan",
            "Vanuatu",
            "Venezuela, Bolivarian Republic of",
            "Vietnam",
            "Virgin Islands, British",
            "Virgin Islands, US",
            "Wallis and Futuna",
            "Yemen",
            "Zambia",
            "Zimbabwe",
          ],
          TitleOfPropertyManagementRepresentative: ["Property Management Company", "Agent"],
        },
      }
    }
}

export default options;